var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFrame = function SvgFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0169 20.0338C15.9968 20.0338 20.0338 15.9968 20.0338 11.0169C20.0338 6.03702 15.9968 2 11.0169 2C6.03702 2 2 6.03702 2 11.0169C2 15.9968 6.03702 20.0338 11.0169 20.0338Z",
    stroke: "#0B072A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0172 7.48602C13.2493 6.71815 12.1885 6.24323 11.0168 6.24323C9.84504 6.24323 8.78423 6.71815 8.01636 7.48602",
    stroke: "#0B072A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 17.4993L22.0002 22",
    stroke: "#0B072A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFrame);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjAxNjkgMjAuMDMzOEMxNS45OTY4IDIwLjAzMzggMjAuMDMzOCAxNS45OTY4IDIwLjAzMzggMTEuMDE2OUMyMC4wMzM4IDYuMDM3MDIgMTUuOTk2OCAyIDExLjAxNjkgMkM2LjAzNzAyIDIgMiA2LjAzNzAyIDIgMTEuMDE2OUMyIDE1Ljk5NjggNi4wMzcwMiAyMC4wMzM4IDExLjAxNjkgMjAuMDMzOFoiIHN0cm9rZT0iIzBCMDcyQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjAxNzIgNy40ODYwMkMxMy4yNDkzIDYuNzE4MTUgMTIuMTg4NSA2LjI0MzIzIDExLjAxNjggNi4yNDMyM0M5Ljg0NTA0IDYuMjQzMjMgOC43ODQyMyA2LjcxODE1IDguMDE2MzYgNy40ODYwMiIgc3Ryb2tlPSIjMEIwNzJBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy40OTk1IDE3LjQ5OTNMMjIuMDAwMiAyMiIgc3Ryb2tlPSIjMEIwNzJBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";